import _ from "lodash";
import React from "react";

import UserAccessPoint from "MessagingV2/components/UserAccessPoint";
import { CHANNEL_TYPES_LIST, CHAT_TYPE_BE } from "MessagingV2/modules/Utils";
import MessagingAvatar from "./Avatar";

const AvatarWithAccessPoint = props => {
  const {
    url,
    icon,
    onlineStatus,
    id,
    name,
    chatType,
    customAvatarStyles,
    isArchived,
    customAvatarContainerClassName,
    hashtagIconStyle,
    isDisabled = false,
  } = props;

  const isPersonalChat =
    _.isEqual(chatType, CHAT_TYPE_BE.CHAT_PERSONAL) ||
    !_.includes(CHANNEL_TYPES_LIST, chatType);

  const avatarComponent = (
    <MessagingAvatar
      url={url}
      icon={icon}
      onlineStatus={onlineStatus}
      id={id}
      name={name}
      chatType={chatType}
      customAvatarStyles={customAvatarStyles}
      isArchived={isArchived}
      customAvatarContainerClassName={customAvatarContainerClassName}
      hashtagIconStyle={hashtagIconStyle}
      isDisabled={isDisabled}
    />
  );

  return isPersonalChat ? (
    <UserAccessPoint profileImage={url} {...props}>
      <div>{avatarComponent}</div>
    </UserAccessPoint>
  ) : (
    avatarComponent
  );
};

export default AvatarWithAccessPoint;
